import { useTranslation } from "react-i18next";
import Modal from "@cloudscape-design/components/modal";
import Box from "@cloudscape-design/components/box";
import SpaceBetween from "@cloudscape-design/components/space-between";
import Button from "@cloudscape-design/components/button";
import Alert from "@cloudscape-design/components/alert";

function DeleteConfirmModal({ scenario, onConfirm, onCancel, visible, loading }) {
  const { t } = useTranslation();

  return (
    <Modal
      visible={visible}
      onDismiss={onCancel}
      header={t("scenarios.delete.title")}
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="link" onClick={onCancel} disabled={loading}>{t("scenarios.delete.cancel")}</Button>
            <Button variant="primary" onClick={onConfirm} loading={loading}>{t("scenarios.delete.confirm")}</Button>
          </SpaceBetween>
        </Box>
      }
    >
      <SpaceBetween size="m">
        <Alert type="warning">{t("scenarios.delete.warning")}</Alert>
        <Box>{t("scenarios.delete.message", { name: scenario?.name || "" })}</Box>
      </SpaceBetween>
    </Modal>
  );
}

export default DeleteConfirmModal;
